<template>
  <div>
    <!-- DESKTOP -->
    <div class="row mobile-none" v-if="view_type == 'desktop'">
      <!-- LIST -->
      <div class="col-12 mt-3">
        <!-- DESTINATION -->
        <div v-if="filter.destination.list.length > 0" class="border cursor-pointer mb-2 position-relative bg-white d-inline-block radius-0 px-4 mr-2 h-54px py-1 top-mt-5px" :class="{'py-12px':backdrop!='destination','z-index-1039':is_backdrop_for_advance}">
          <!-- <p class="mb-0 font-semibold text-14 d-inline-block mr-2 text-semi-dark" v-if="backdrop!='destination'">Destination</p> -->
          <div @click="toggleBackdrop('destination')">
            <div class="position-relative top-4px pr-4">
              <p class="mb-0 text-11 font-regular color-grey-ota">Destination</p>
              <p class="mb-0 text-14 font-bold text-semi-dark">{{filter.destination.selected.name}}</p>
            </div>
            <svg class="b-a-ota" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"></path></svg>
          </div>

          <!-- DETAIL -->
          <div class="position-absolute bg-white border rounded-6 py-2 box-shadow-primary rooms-guest z-index-1039 popup-detail w-500" v-if="backdrop == 'destination'">
            <div class="py-2 mb-2">
              <div class="px-3 d-block">
                <p class="mb-2 body-2-2 font-bold text-14">Destination Area</p>
                <div v-for="(dest,index) in filter.destination.list" :key="index" @click="selectFilterItem('destination',dest)" class="border rounded-6 text-center cursor-pointer p-2 d-inline-block mr-2">
                  <p class="mb-0 text-14 font-semibold" :class="{'color-primary-ota':dest.id == filter.destination.selected.id}">{{$capitalize(dest.name)}}</p>
                </div>
              </div>
              <div class="border-top mt-3 pt-3">
                <div class="px-3 text-right">
                  <button @click="resetBtn('destination')" class="px-23rm border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
                    Reset
                  </button>
                  <button @click="applyBtn('destination')" class="px-23rm g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- STAR -->
        <div class="border cursor-pointer mb-2 position-relative bg-white d-inline-block radius-0 px-4 mr-2 h-54px py-1 top-mt-5px" :class="{'py-12px':backdrop!='star','z-index-1039':is_backdrop_for_advance}">
          <div @click="toggleBackdrop('star')">
            <div class="position-relative top-4px pr-4">
              <p class="mb-0 text-11 font-regular color-grey-ota">Hotel Star</p>
              <p class="mb-0 text-14 font-bold text-semi-dark">{{filter.star.selected.title}}</p>
            </div>
            <svg class="b-a-ota" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"></path></svg>
          </div>

          <!-- DETAIL -->
          <div class="position-absolute bg-white border rounded-6 py-2 box-shadow-primary rooms-guest z-index-1039 popup-detail w-400" v-if="backdrop == 'star'">
            <div class="py-2 mb-2">
              <div class="px-3 d-block">
                <p class="mb-2 body-2-2 font-bold text-14">Hotel Star</p>
                <div v-for="(star,index) in filter.star.list" :key="index" @click="selectFilterItem('star',star)" class="border rounded-6 text-center cursor-pointer p-2 d-inline-block mr-2" :class="{'py-2 px-3':index != 0}">
                  <p class="mb-0 text-14 font-semibold" :class="{'color-primary-ota':star.id == filter.star.selected.id}">{{star.title}}</p>
                </div>
              </div>
              <div class="border-top mt-3 pt-3">
                <div class="px-3 text-right">
                  <button @click="resetBtn('star')" class="px-23rm border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
                    Reset
                  </button>
                  <button @click="applyBtn('star')" class="px-23rm g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- TYPE -->
        <div v-if="filter.type.list.length > 0" class="border cursor-pointer mb-2 position-relative bg-white d-inline-block radius-0 px-4 mr-2 h-54px py-1 top-mt-5px" :class="{'py-12px':backdrop!='type','z-index-1039':is_backdrop_for_advance}">
          <div @click="toggleBackdrop('type')">
            <div class="position-relative top-4px pr-4">
              <p class="mb-0 text-11 font-regular color-grey-ota">Property Type</p>
              <p class="mb-0 text-14 font-bold text-semi-dark">{{$capitalize(filter.type.selected.name)}}</p>
            </div>
            <svg class="b-a-ota" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"></path></svg>
          </div>

          <!-- DETAIL -->
          <div class="position-absolute bg-white border rounded-6 py-2 box-shadow-primary rooms-guest z-index-1039 popup-detail w-400" v-if="backdrop == 'type'">
            <div class="py-2 mb-2">
              <div class="px-3 d-block">
                <p class="mb-2 body-2-2 font-bold text-14">Property Type</p>
                <div v-for="(type,index) in filter.type.list" :key="index" @click="selectFilterItem('type',type)" class="border rounded-6 text-center cursor-pointer p-2 d-inline-block mr-2">
                  <p class="mb-0 text-14 font-semibold" :class="{'color-primary-ota':type.id == filter.type.selected.id}">{{$capitalize(type.name)}}</p>
                </div>
              </div>
              <div class="border-top mt-3 pt-3">
                <div class="px-3 text-right">
                  <button @click="resetBtn('type')" class="px-23rm border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
                    Reset
                  </button>
                  <button @click="applyBtn('type')" class="px-23rm g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PRICE -->
        <div class="border cursor-pointer mb-2 position-relative bg-white d-inline-block radius-0 px-4 mr-2 h-54px py-1 top-mt-5px " :class="{'py-12px':backdrop!='price','z-index-1039':is_backdrop_for_advance}">
          <div @click="toggleBackdrop('price')">
            <div class="position-relative top-4px pr-4">
              <p class="mb-0 text-11 font-regular color-grey-ota">Price</p>
              <p class="mb-0 text-14 font-bold text-semi-dark">{{ filter.price.display }}</p>
            </div>
            <svg class="b-a-ota" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"></path></svg>
          </div>

          <!-- DETAIL -->
          <div class="position-absolute bg-white border rounded-6 py-2 box-shadow-primary rooms-guest z-index-1039 popup-detail w-500" v-if="backdrop == 'price'">
            <div class="py-2 mb-2">
              <div class="px-3 d-block">
                <p class="mb-2 body-2-2 font-bold text-14" style="text-transform: capitalize;">{{$t('hotel.filter.desc')}}</p>
                <div class="row no-gutters mt-2" :key="filter.price.key">
                  <div class="col-5 align-self-center">
                    <div class="w-100 mb-1" @click="togglePrice('min')">
                      <div class="w-16px rounded border-primary-ota text-center delay mr-1 d-inline-block cursor-pointer align-middle" :class="{'bg-primary-ota':filter.price.min.use}" style="border-width: 2px !important;">
                        <img src="../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -8px">
                      </div>
                      <p class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle">Minimun</p>
                    </div>
                    <input-currency v-model="filter.price.min.data" v-if="filter.price.min.active_form" @onback-blur="priceHandler('min',false)">
                    </input-currency>
                    <p class="border mb-0 p-2 rounded-4 body-2-2 font-semibold"
                      :class="{'cursor-disable bg-custom-light':!filter.price.min.use}" 
                      v-else 
                      @click="priceHandler('min', true)">
                      {{$formatCurrency(filter.price.min.data)}}
                    </p>
                  </div>
                  <div class="col-2 align-self-center pt-4">
                    <p class="text-20 mt-2 font-weight-bold w-100 text-center">-</p>
                  </div>
                  <div class="col-5 align-self-center">
                    <div class="w-100 mb-1" @click="togglePrice('max')">
                      <div class="w-16px rounded border-primary-ota text-center delay mr-1 d-inline-block cursor-pointer align-middle" :class="{'bg-primary-ota':filter.price.max.use}" style="border-width: 2px !important;">
                        <img src="../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -8px">
                      </div>
                      <p class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle">Maximum</p>
                    </div>
                    <input-currency v-model="filter.price.max.data" v-if="filter.price.max.active_form" @onback-blur="priceHandler('max',false)">
                    </input-currency>
                    <p class="border mb-0 p-2 rounded-4 body-2-2 font-semibold" 
                      :class="{'cursor-disable bg-custom-light':!filter.price.max.use}"
                      v-else 
                      @click="priceHandler('max', true)">
                      {{$formatCurrency(filter.price.max.data)}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="border-top mt-3 pt-3">
                <div class="px-3 text-right">
                  <button @click="resetBtn('price')" class="px-23rm border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
                    Reset
                  </button>
                  <button @click="applyBtn('price')" class="px-23rm g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- FACILITY -->
        <div v-if="filter.facility.list.length > 0" class="border cursor-pointer mb-2 position-relative bg-white d-inline-block radius-0 px-4 mr-2 h-54px py-1 top-mt-5px" :class="{'py-12px':backdrop!='facility','z-index-1039':is_backdrop_for_advance}">
          <div @click="toggleBackdrop('facility')">
            <div class="position-relative top-4px pr-4">
              <p class="mb-0 text-11 font-regular color-grey-ota">Facilities</p>
              <p class="mb-0 text-14 font-bold text-semi-dark">{{filter.facility.list.filter(x=>x.selected).length == 0 ? 'All Facilities' : `${filter.facility.list.filter(x=>x.selected).length} facility selected`}}</p>
            </div>
            <svg class="b-a-ota" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.47412 4.51844C2.64457 4.34457 2.91129 4.32877 3.09925 4.47102L3.15309 4.51844L7.00016 8.44283L10.8472 4.51844C11.0177 4.34457 11.2844 4.32877 11.4724 4.47102L11.5262 4.51844C11.6967 4.69231 11.7122 4.96438 11.5727 5.15611L11.5262 5.21104L7.33965 9.48156C7.1692 9.65543 6.90248 9.67123 6.71452 9.52898L6.66067 9.48156L2.47412 5.21104C2.28662 5.01978 2.28662 4.7097 2.47412 4.51844Z" fill="#999999"></path></svg>
          </div>

          <!-- DETAIL -->
          <div class="position-absolute bg-white border rounded-6 py-2 box-shadow-primary rooms-guest z-index-1039 popup-detail w-600" v-if="backdrop == 'facility'">
            <div class="py-2 mb-2">
              <div class="px-3 d-block">
                <p class="mb-3 body-2-2 font-bold text-14">Facilities</p>
                <div class="row">
                  <div class="col-4 mb-3" v-for="(fac,index) in filter.facility.list" @click="selectFacility(index)">
                    <div class="row slim-grid-row-1">
                      <div class="col-2">
                        <div class="position-relative">
                          <div class="border rounded-6 w-24px text-center align-self-center cursor-pointer" :class="{'bg-primary-opacity':fac.selected}">
                          </div>
                          <svg v-if="fac.selected" class="fill-primary position-absolute" style="top: 6px;left: 5px;" width="14" height="12" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.17994 2.24012L4.42994 6.99012C4.25994 7.16012 4.03994 7.24012 3.80994 7.24012C3.58994 7.24012 3.36994 7.16012 3.19994 6.99012L0.819941 4.62012C0.479941 4.27012 0.479941 3.72012 0.819941 3.38012C1.15994 3.04012 1.71994 3.04012 2.05994 3.38012L3.80994 5.13012L7.93994 1.00012C8.27994 0.660117 8.83994 0.660117 9.17994 1.00012C9.51994 1.35012 9.51994 1.90012 9.17994 2.24012" fill="#26B11D"/>
                          </svg>
                        </div>
                      </div>
                      <div class="col-10">
                        <p class="mb-0 text-14 font-semibold cursor-pointer" :class="fac.selected?'text-semi-dark':'color-grey-ga'">{{fac.name}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="border-top mt-3 pt-3">
                <div class="px-3 text-right">
                  <button @click="resetBtn('facility')" class="px-23rm border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
                    Reset
                  </button>
                  <button @click="applyBtn('facility')" class="px-23rm g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MOBILE -->
    <template v-if="view_type == 'mobile'">
      <popup-detail 
        :show="show_mobile"
        direction="bottom" 
        :size="102"
        @close="toggleMobileView">
        <template v-slot:body>
          <div class="px-4 py-3 border-bottom position-fixed w-100 bg-white z-index-1045" style="top:14px">
            <div class="row">
              <div class="col-10">
                <p class="mb-0 font-bold text-16 mt-1 text-semi-dark">Filter</p>
                <p class="mb-0 font-regular text-13 color-grey">Filter the date according to your wishes</p>
              </div>
              <div class="col-2 text-right">
                <svg width="34" height="34" @click="toggleMobileView()" class="position-relative cursor-pointer" style="top: 7px;" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.5" width="33" height="33" rx="6.5" fill="white"/>
                  <path d="M23.7998 11.21L22.3898 9.80005L16.7998 15.39L11.2098 9.80005L9.7998 11.21L15.3898 16.8L9.7998 22.39L11.2098 23.8L16.7998 18.21L22.3898 23.8L23.7998 22.39L18.2098 16.8L23.7998 11.21Z" fill="#222222"/>
                  <rect x="0.5" y="0.5" width="33" height="33" rx="6.5" stroke="#DDDDDD"/>
                </svg>
              </div>
            </div>
          </div>
          <div class="p-4" style="margin-top:100px">
            <!-- DESTINATION -->
            <div class="pb-2 border-bottom mb-4">
              <p class="mb-2 body-2-2 font-bold text-14">Destination Area</p>
              <div v-for="(dest,index) in filter.destination.list" :key="index" @click="selectFilterItem('destination',dest)" class="border rounded-6 text-center cursor-pointer py-2 px-3 d-inline-block mr-2 mb-3">
                <p class="mb-0 text-14 font-semibold" :class="{'color-primary-ota':dest.id == filter.destination.selected.id}">{{$capitalize(dest.name)}}</p>
              </div>
            </div>
            
            <!-- STAR -->
            <div class="pb-2 border-bottom mb-4">
              <div class="d-block">
                <p class="mb-2 body-2-2 font-bold text-14">Hotel Star</p>
                <div v-for="(star,index) in filter.star.list" :key="index" @click="selectFilterItem('star',star)" class="border rounded-6 text-center cursor-pointer py-2 px-3 mb-3 d-inline-block mr-2">
                  <p class="mb-0 text-14 font-semibold" :class="{'color-primary-ota':star.id == filter.star.selected.id}">{{star.title}}</p>
                </div>
              </div>
            </div>

            <!-- PROPERTY TYPE -->
            <div class="pb-2 border-bottom mb-4">
              <p class="mb-2 body-2-2 font-bold text-14">Property Type</p>
              <div v-for="(type,index) in filter.type.list" :key="index" @click="selectFilterItem('type',type)" class="border rounded-6 text-center cursor-pointer py-2 px-3 d-inline-block mr-2 mb-3">
                <p class="mb-0 text-14 font-semibold" :class="{'color-primary-ota':type.id == filter.type.selected.id}">{{$capitalize(type.name)}}</p>
              </div>
            </div>

            <!-- PRICE -->
            <div class="pb-4 border-bottom mb-4">
              <p class="mb-2 body-2-2 font-bold text-14" style="text-transform: capitalize;">{{$t('hotel.filter.desc')}}</p>
              <div class="row no-gutters mt-2" :key="filter.price.key">
                <div class="col-5 align-self-center">
                  <div class="w-100 mb-1" @click="togglePrice('min')">
                    <div class="w-16px rounded border-primary-ota text-center delay mr-1 d-inline-block cursor-pointer align-middle" :class="{'bg-primary-ota':filter.price.min.use}" style="border-width: 2px !important;">
                      <img src="../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -8px">
                    </div>
                    <p class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle">Minimun</p>
                  </div>
                  <input-currency v-model="filter.price.min.data" v-if="filter.price.min.active_form" @onback-blur="priceHandler('min',false)">
                  </input-currency>
                  <p class="border mb-0 p-2 rounded-4 body-2-2 font-semibold"
                    :class="{'cursor-disable bg-custom-light':!filter.price.min.use}" 
                    v-else 
                    @click="priceHandler('min', true)">
                    {{$formatCurrency(filter.price.min.data)}}
                  </p>
                </div>
                <div class="col-2 align-self-center pt-4">
                  <p class="text-20 mt-2 font-weight-bold w-100 text-center">-</p>
                </div>
                <div class="col-5 align-self-center">
                  <div class="w-100 mb-1" @click="togglePrice('max')">
                    <div class="w-16px rounded border-primary-ota text-center delay mr-1 d-inline-block cursor-pointer align-middle" :class="{'bg-primary-ota':filter.price.max.use}" style="border-width: 2px !important;">
                      <img src="../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="top: -8px">
                    </div>
                    <p class="body-2-1 mb-0 d-inline-block cursor-pointer align-middle">Maximum</p>
                  </div>
                  <input-currency v-model="filter.price.max.data" v-if="filter.price.max.active_form" @onback-blur="priceHandler('max',false)">
                  </input-currency>
                  <p class="border mb-0 p-2 rounded-4 body-2-2 font-semibold" 
                    :class="{'cursor-disable bg-custom-light':!filter.price.max.use}"
                    v-else 
                    @click="priceHandler('max', true)">
                    {{$formatCurrency(filter.price.max.data)}}
                  </p>
                </div>
              </div>
            </div>

            <!-- FACILITY -->
            <div class="w-100">
              <p class="mb-3 body-2-2 font-bold text-14">Facilities</p>
              <div class="row slim-grid-row">
                <div class="col-4 mb-3" v-for="(fac,index) in filter.facility.list" @click="selectFacility(index)">
                  <div class="row slim-grid-row-1">
                    <div class="col-2">
                      <div class="position-relative">
                        <div class="border rounded-6 w-24px text-center align-self-center cursor-pointer" :class="{'bg-primary-opacity':fac.selected}">
                        </div>
                        <svg v-if="fac.selected" class="fill-primary position-absolute" style="top: 6px;left: 5px;" width="14" height="12" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.17994 2.24012L4.42994 6.99012C4.25994 7.16012 4.03994 7.24012 3.80994 7.24012C3.58994 7.24012 3.36994 7.16012 3.19994 6.99012L0.819941 4.62012C0.479941 4.27012 0.479941 3.72012 0.819941 3.38012C1.15994 3.04012 1.71994 3.04012 2.05994 3.38012L3.80994 5.13012L7.93994 1.00012C8.27994 0.660117 8.83994 0.660117 9.17994 1.00012C9.51994 1.35012 9.51994 1.90012 9.17994 2.24012" fill="#26B11D"/>
                        </svg>
                      </div>
                    </div>
                    <div class="col-10">
                      <p class="mb-0 text-14 font-semibold cursor-pointer pl-2" :class="fac.selected?'text-semi-dark':'color-grey-ga'">{{fac.name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top position-fixed w-100" style="bottom:0px">
            <div class="row">
              <div class="col-6">
                <button @click="resetBtn('all')" class="w-100 border-none g-btn-primary-ota-outline g-btn-lg radius-0 py-12px text-color-red mr-2" type="button">
                  Reset
                </button>
              </div>
              <div class="col-6">
                <button @click="applyBtn('all')" class="w-100 g-btn-primary-ota g-btn-lg radius-0 py-12px border-none" type="button">
                  <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="7.84442" cy="7.84442" r="5.99237" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.0122 12.3235L14.3616 14.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>Search</span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </popup-detail>
    </template>
  </div>
</template>
<script>
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  
  export default{
    props: ['destination','merchant_category','facility','backdrop','default_filter'],
    components:{
      PopUpBackground
    },
    data(){
      return{
        view_type: 'desktop',
        show_mobile:false,
        filter:{
          destination:{
            list: this.destination,
            selected: this.destination.length > 0 ? this.destination[0] : {}
          },
          star:{
						list: [{ id: 'all', title: 'All Star' },{ id: '1', title: '1' },{ id: '2', title: '2' },{ id: '3', title: '3' },{ id: '4', title: '4' },{ id: '5', title: '5+' }],
						selected: { id: 'all', title: 'All Star' }
					},
					price:{
            display: 'All Prices',
            key: 0,
            min:{
              use:false,
              active_form: false,
              data: 0
            },
            max:{
              active_form: false,
              data: 0
            }
					},
					type:{
						list: this.merchant_category,
						selected: this.merchant_category.length > 0 ? this.merchant_category[0] : {}
					},
					facility:{
						list: this.facility
					}
        }
      }
    },
    watch:{
      backdrop(){
        if(this.is_backdrop_for_advance && window.innerWidth <= 992){
          this.toggleMobileView()
        }
      }
    },
    computed:{
      is_backdrop_for_advance(){
        return this.backdrop == 'destination' || this.backdrop == 'star' || this.backdrop == 'type' || this.backdrop == 'price' || this.backdrop == 'facility' ? true : false
      }
    },
    mounted(){
      this.fillDefaultValue()
      this.checkViewType()
    },
    methods:{
      toggleBackdrop(data=''){
				this.$emit("toggleBackdrop", data)
	    },
      selectFilterItem(field,data){
        this.filter[field].selected = data
      },
      resetBtn(field){
        if(field == 'all'){
          this.filter.destination.selected = this.filter.destination.list[0]
          this.filter.star.selected = this.filter.star.list[0]
          this.filter.type.selected = this.filter.type.list[0]
          this.filter.price.min={
            use:false,
            active_form: false,
            data: 0
          }
          this.filter.price.max={
            use:false,
            active_form: false,
            data: 0
          }
          this.filter.facility.list = this.filter.facility.list.map(x=>{
            delete x.selected
            let return_data = {
              selected: false,
              ...x
            }
            return return_data
          })
        }else{
          this.filter[field].selected = this.filter[field].list[0]
          if(field == 'price'){
            this.filter.price.min={
              use:false,
              active_form: false,
              data: 0
            }
            
            this.filter.price.max={
              use:false,
              active_form: false,
              data: 0
            }
          }
          if(field == 'facility'){
            this.filter.facility.list = this.filter.facility.list.map(x=>{
              delete x.selected
              let return_data = {
                selected: false,
                ...x
              }
              return return_data
            })
          }
        }
      },
      applyBtn(field){
        let params = {
          type: field,
          data:null
        }
        if(field == 'destination' || field == 'star' || field == 'type'){
          params.data = this.filter[field].selected.id
        }
        if(field == 'price'){
          params.data = {
            min: this.filter.price.min.data,
            max: this.filter.price.max.data,
          }
        }
        if(field == 'facility'){
          params.data = this.filter.facility.list.filter(x=>x.selected)
        }

        if(field == 'all'){
          params.data = {
            destination: this.filter.destination.selected.id,
            star: this.filter.star.selected.id,   
            type: this.filter.type.selected.id,
            price:{
              min: this.filter.price.min.data,
              max: this.filter.price.max.data,
            },
            facility: this.filter.facility.list.filter(x=>x.selected)
          }
        }

        this.$emit('applyFilter',params)
        this.toggleBackdrop()
        this.show_mobile = false
      },
      togglePrice(field){
        this.filter.price[field].use = !this.filter.price[field].use
        this.filter.price.key++
        if(!this.filter.price[field].use){
          this.filter.price[field].active_form = false
          this.filter.price[field].data = 0
        }
        this.setupPriceDisplay()
      },
      priceHandler(field, data){
        if(this.filter.price[field].use){
          var regex_first_zero = /^(?:[1-9][0-9]*|0)$/;
          var regex_number_comma_dot = /^[0-9.,]+$/;
          
          if(regex_number_comma_dot.test(this.filter.price[field].data) == false){
            this.filter.price[field].data = 0
          }else if(regex_first_zero.test(this.filter.price[field].data) == false){
            this.filter.price[field].data = +this.filter.price[field].data
          }
          this.filter.price[field].active_form = data
          this.setupPriceDisplay()
        }
	    },
      setupPriceDisplay(){
        if(this.filter.price.min.data == 0 && this.filter.price.max.data == 0){
          this.filter.price.display = 'All Prices'
        }else{
          if(this.filter.price.min.data > 0 && this.filter.price.max.data > 0){
            this.filter.price.display = `${this.$formatCurrency(this.filter.price.min.data)} - ${this.$formatCurrency(this.filter.price.max.data)}`
          }else{
            if(this.filter.price.min.data > 0){
              this.filter.price.display = `Minimum ${this.$formatCurrency(this.filter.price.min.data)}`
            }else{
              this.filter.price.display = `Maximum ${this.$formatCurrency(this.filter.price.max.data)}`
            }
          }
        }
      },
      selectFacility(index){
        this.filter.facility.list[index].selected = !this.filter.facility.list[index].selected
      },
      toggleMobileView(){
        this.show_mobile = !this.show_mobile
        if(!this.show_mobile){
          this.toggleBackdrop('')
        }
      },
      checkViewType(){
        if(window.innerWidth <= 992){
          this.view_type = 'mobile'
        }
      },
      fillDefaultValue(){
        this.filter.destination.selected = this.default_filter.destination_area_id == '' ? this.filter.destination.list[0] : this.filter.destination.list.find(x=>x.id == this.default_filter.destination_area_id)
        this.filter.star.selected = this.default_filter.merchant_star == '' ? this.filter.star.list[0] : this.filter.star.list.find(x=>x.id == this.default_filter.merchant_star)
        this.filter.type.selected = this.default_filter.merchant_type_category == '' ? this.filter.type.list[0] : this.filter.type.list.find(x=>x.id == this.default_filter.merchant_type_category)
        if(this.default_filter.price_min != ''){
          this.filter.price.min = {
            use: true,
            active_form: false,
            data: Number(this.default_filter.price_min)
          }
        }
        if(this.default_filter.price_max != ''){
          this.filter.price.max = {
            use: true,
            active_form: false,
            data: Number(this.default_filter.price_max)
          }
        }
        this.setupPriceDisplay()
        if(this.default_filter.merchant_facility.length > 0){
          this.default_filter.merchant_facility.forEach(x => {
            let index_match = this.filter.facility.list.findIndex(y=>y.id == x)
            if(index_match != -1){
              this.filter.facility.list[index_match].selected = true
            }
          })
        }
      }
    }
  }
</script>
<style scoped>
  .w-500{
    width: 500px;
  }
  .w-400{
    width: 400px;
  }
  .w-600{
    width: 600px;
  }
  .popup-detail{
    position: absolute;
    top:60px;
    left: 0px;
  }
</style>


// WEBPACK FOOTER //
// src/components/community/AdvanceFilter.vue